import React, { useEffect, useState } from 'react';
import Slider from "react-slick";
import { Link, NavLink } from 'react-router-dom';
import { products_list, productDetails } from '../services/Product-service';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { formatPrice } from "../utils/formatPrice";

function NewArrivals({ shownewarrivals, sectionTitle }) {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [productArr, setProductArr] = useState([]);
    const [lowestPrices, setLowestPrices] = useState({});

    const CustomPrevArrow = ({ className, style, onClick, isDisabled }) => (
        <button
            className={className}
            style={{
                ...style,
                display: isDisabled ? "none" : "block",
            }}
            onClick={!isDisabled ? onClick : null}
        />
    );

    const CustomNextArrow = ({ className, style, onClick }) => (
        <button className={className} style={{ ...style }} onClick={onClick} />
    );

    useEffect(() => {
        if (!shownewarrivals) return;

        products_list({
            offset: 0,
            limit: 8,
            sort_by: 'newest',
        }).then((data) => {
            setProductArr((data.products || []).slice(0, 8));
        }).catch((error) => {
            console.error("Error fetching new arrivals:", error);
        });
    }, [shownewarrivals]);

    useEffect(() => {
        if (!productArr || productArr.length === 0) return;

        productArr.forEach((product) => {
            const prodId = product.id;
            if (prodId && lowestPrices[prodId] === undefined) {
                setLowestPrices((prev) => ({ ...prev, [prodId]: null }));

                productDetails(prodId)
                    .then((data) => {
                        if (data && data.productvariants && data.productvariants.length > 0) {
                            const sizeOrder = ['3xs', 'xxs', 'xs', 's', 'm', 'l', 'xl', '2xl', 'xxl', '3xl', 'xxxl', '4xl', '5xl', '6xl'];
                            const sortedVars = [...data.productvariants].sort((a, b) => {
                                const sizeA = (a.size || '').toLowerCase().trim();
                                const sizeB = (b.size || '').toLowerCase().trim();
                                const indexA = sizeOrder.indexOf(sizeA);
                                const indexB = sizeOrder.indexOf(sizeB);
                                if (indexA === -1 && indexB === -1) return 0;
                                if (indexA === -1) return 1;
                                if (indexB === -1) return -1;
                                return indexA - indexB;
                            });
                            const lowestVariant = sortedVars[0];
                            setLowestPrices((prev) => ({
                                ...prev,
                                [prodId]: {
                                    price: Number(lowestVariant?.price || product.price) || 0,
                                    saleprice: Number(lowestVariant?.saleprice || product.saleprice) || 0
                                }
                            }));
                        } else {
                            setLowestPrices((prev) => ({
                                ...prev,
                                [prodId]: {
                                    price: Number(product.price) || 0,
                                    saleprice: Number(product.saleprice) || 0
                                }
                            }));
                        }
                    })
                    .catch(() => {
                        setLowestPrices((prev) => ({
                            ...prev,
                            [prodId]: {
                                price: Number(product.price) || 0,
                                saleprice: Number(product.saleprice) || 0
                            }
                        }));
                    });
            }
        });
    }, [productArr]);

    const totalItems = productArr.length;
    const desktopSlidesToShow = 5;
    const tabletSlidesToShow = 2;
    const mobileSlidesToShow = 2;

    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: Math.min(desktopSlidesToShow, totalItems || 1),
        slidesToScroll: totalItems > desktopSlidesToShow ? desktopSlidesToShow : 1,
        initialSlide: 0,
        beforeChange: (oldIndex, newIndex) => setCurrentSlide(newIndex),
        prevArrow: <CustomPrevArrow isDisabled={currentSlide === 0} />,
        nextArrow: <CustomNextArrow />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    dots: false,
                    infinite: false,
                    slidesToShow: Math.min(desktopSlidesToShow, totalItems || 1),
                    slidesToScroll: totalItems > desktopSlidesToShow ? desktopSlidesToShow : 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    dots: false,
                    infinite: false,
                    slidesToShow: Math.min(tabletSlidesToShow, totalItems || 1),
                    slidesToScroll: totalItems > tabletSlidesToShow ? tabletSlidesToShow : 1,
                    initialSlide: 0
                }
            },
            {
                breakpoint: 480,
                settings: {
                    dots: false,
                    infinite: false,
                    slidesToShow: Math.min(mobileSlidesToShow, totalItems || 1),
                    slidesToScroll: totalItems > mobileSlidesToShow ? mobileSlidesToShow : 1,
                    arrows: false,
                    initialSlide: 0
                }
            },
        ]
    };

    if (!shownewarrivals || totalItems === 0) return null;

    return (
        <div>
            <div className='App'>
                <div className="BreakPointContainer">
                    <div className="CarouselSectionContainer new-arrivals">
                        <div className="layout row justify-space-between align-center text-left SectionTitle">
                            <h1 className='m-t-0 m-b-0 demi-bold w-auto'> {sectionTitle || 'NEW ARRIVALS'} </h1>
                            <NavLink to="/category?sort_by=newest" className='ViewAllUrlsLink orat-color-hover h5 demi-bold w-auto'>VIEW ALL</NavLink>
                        </div>
                        <div className="layout">
                            <div className="flex left-align-slick xs12">
                                <Slider key={Object.keys(lowestPrices).length} {...settings}>
                                    {productArr.map((data, index) => (
                                        <div className='item sjl' key={data.id || index}>
                                            <div className="CarouselSection category">
                                                <div className="prel Gutter">
                                                    <Link to={`/products/productdetails/${data.id}`}>
                                                        <div className="DynamicHeightLoaderWrapper" style={{ paddingTop: '112%' }}>
                                                            <div className="DynamicHeightLoader layout row align-center justify-center" style={{ paddingTop: '32%' }}>
                                                                <img src={data.product_thumbail} alt={data.product_title} className='img-resp DynamicHeightLoaderImage' style={{ padding: '0px' }} />
                                                            </div>
                                                            <div className="animated-bg-placeholder"></div>
                                                        </div>
                                                        <div className="ImageTextDetail ProductImageTextDetail">
                                                            <label className="ellipsis h5 ImageTextLabelTop m-t-5 demi-bold"> {data.product_title} </label>
                                                            <label className="h6 ellipsis-two-line font-normal ImageTextLabelBottom block font-normal">{data.product_short_description}</label>
                                                            <div className="ProductPrice layout row wrap">
                                                                {(() => {
                                                                    const lowestInfo = lowestPrices[data.id];
                                                                    const finalPrice = lowestInfo
                                                                        ? (lowestInfo.saleprice > 0 ? lowestInfo.saleprice : lowestInfo.price)
                                                                        : (data?.saleprice > 0 ? data.saleprice : data.price);
                                                                    return (
                                                                        <span className='SpecialPrice p2 demi-bold w-auto p-0 detail_spc' style={{ marginLeft: '5%' }}>
                                                                            ₹{formatPrice(finalPrice, { showSymbol: false })}
                                                                        </span>
                                                                    );
                                                                })()}
                                                                {data?.discount_amount > 0 && (<span className='InitialPrice p3 w-auto p-0'> ₹{formatPrice(data?.price, { showSymbol: false })} </span>)}
                                                                <span className='DiscountPriceRound p3 w-auto p-0'>
                                                                    {data?.discount_type == 'flat' ? `${data?.discount_amount} FLAT OFF` : ''}
                                                                    {data?.discount_type == 'percentage' ? `${data?.discount_amount}% OFF` : ''} </span>
                                                            </div>
                                                        </div>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default NewArrivals;
